var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopa = function SvgCopa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.25 10a1.25 1.25 0 1 0-2.5 0v1.667a1.25 1.25 0 0 0 2.5 0zM15 20.417c.69 0 1.25.56 1.25 1.25v5a1.25 1.25 0 1 1-2.5 0v-5c0-.69.56-1.25 1.25-1.25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.083 8.333a4.583 4.583 0 0 1 4.584-4.583h16.666a4.583 4.583 0 0 1 4.584 4.583v23.334a4.583 4.583 0 0 1-4.584 4.583H11.667a4.584 4.584 0 0 1-4.584-4.583zm3.11-1.473c.391-.39.921-.61 1.474-.61h16.666a2.084 2.084 0 0 1 2.084 2.083v7.083H9.583V8.333c0-.552.22-1.082.61-1.473m20.224 11.057v13.75a2.083 2.083 0 0 1-2.084 2.083H11.667a2.083 2.083 0 0 1-2.084-2.083v-13.75z",
    clipRule: "evenodd"
  })));
};
export default SvgCopa;